
/*
var init = [{"id":"zcar_platform_system_mgnt","name":"基礎資料維護","icon":"fa fa-dashboard","active":false,"items":[{"id":"zcar_platform_fleet_car_mgnt","name":"車隊車輛管理","active":false,"parent":"zcar_platform_system_mgnt","link":"FleetCarList"},{"id":"zcar_platform_fleet_customer_mgnt","name":"車隊客戶管理","active":false,"parent":"zcar_platform_system_mgnt","link":"FleetCustomerList"},{"id":"zcar_platform_fleet_driver_mgnt","name":"車隊司機管理","active":false,"parent":"zcar_platform_system_mgnt","link":"FleetDriver"},{"id":"zcar_platform_fleet_member_mgnt","name":"車隊帳號管理","active":false,"parent":"zcar_platform_system_mgnt","link":"FleetMemberList"}]}]
export const menuItemsInit = [
    new MenuObj({
        id: 'Account',
        name:'系統帳號管理',
        icon: 'fa fa-dashboard',
        active: false,
        items: [
            new MenuObj(
            {
                parent:'Account',
                name:'系統帳號管理',
                link: 'AccountList'
            }
            )
        ]
    }),
    {
        id: 'Fleet',
        name:'車隊管理',
        icon: 'fa fa-dashboard',
        items: [
            {
                parent:'Fleet',
                name:'車隊管理',
                link: 'FleetList'
            },
            {
                parent:'Fleet',
                name:'公告發布',
                link: 'FleetAdd'
            }
        ]
    },
    {
        id:'Bl',
        name:'系統公告',
        icon: 'fa fa-dashboard',
        active: false,
        items: [
            {
                parent:'Bl',
                name:'公告',
                link: 'BlList'
            }
        ]
    },
    {
        id: 'FleetMember',
        name:'基礎資料維護',
        icon: 'fa fa-dashboard',
        items: [
            {
                parent: 'FleetMember',
                name:'車隊帳號管理',
                link: 'FleetMemberList'
            },{
                parent: 'FleetMember',
                name:'車隊車輛管理',
                link: 'FleetCarList'
            },{
                parent: 'FleetMember',
                name:'車隊司機管理',
                link: 'FleetDriverList'
            },{
                parent: 'FleetMember',
                name:'車隊客戶管理',
                link: 'FleetCustomerList'
            }
        ]
    },/*
    {
        name:'車隊任務管理',
        icon: 'fa fa-dashboard',
        items: [
            {
                name:'任務派遣',
                link: '/login'
            },{
                name:'任務日程',
                link: '/about'
            },{
                name:'任務執行紀錄',
                link: '/about'
            },
        ]
    },
]
    */

//選單列表
export function getMenuList (){
    var menu = localStorage.getItem("menuList");
    if(menu === undefined || menu === null || menu === ""){
      return [];
    }else{
      var json = JSON.parse(menu);
      return json;
    }
  }
  
  export function setMenuList (menu) {
    var json = JSON.stringify(menu);
    //console.log(json);
    localStorage.setItem("menuList", json);
  }

//頁面列表
export function getMainPageList (){
    var pageList = localStorage.getItem("mainPageList");
    if(pageList === undefined || pageList === null || pageList === ""){
      return [];
    }else{
      var json = JSON.parse(pageList);
      return json;
    }
  }
  
  export function setMainPageList (pageList) {
    var json = JSON.stringify(pageList);
    //console.log(json);
    localStorage.setItem("mainPageList", json);
  }


//選單樹狀結構
export function getMenuItems(){
    var menuItems = localStorage.getItem("menuItems");
    //console.log("getMenuItems")
    if(menuItems === undefined || menuItems === null || menuItems === "undefined"){
        return[]
    }else{
        //console.log(menuItems)
        var json = JSON.parse(menuItems);
        //console.log(json)
        return json;
    }
}

export function originalItems(menuItemsInit){
    //console.log("originalItems")
    var menuItems = setMenuItems(menuItemsInit)
    //console.log(menuItems)
    return menuItems;
}

export function initMenuItems(){
    //console.log("initMenuItems")
    var menuItems = setMenuActive(-1)
    //console.log(menuItems)
    return menuItems;
}

export function setMenuItems(menuItems){
    //console.log(menuItems)
    var json = JSON.stringify(menuItems);
    localStorage.setItem("menuItems", json);
    return json;
}

export function setMenuActive(parent = 0){
    var menuItems = getMenuItems()
   //console.log(menuItems)
   //console.log(parent)
    menuItems.forEach((menuItem, index) => {
        menuItem.items.forEach((item)=>{
            //console.log(item.menuId)
            if(item.menuId === parent){
                item.active = true;
            }else{
                item.active = false;
            }
        })
   });
  // console.log(menuItems)
   setMenuItems(menuItems)
}

export function setMenuActiveId(menuId){
    localStorage.setItem("MenuActiveId", menuId);
}

export function getMenuActiveId(){
    var menuId = localStorage.getItem("MenuActiveId");
    if(menuId === undefined)
    menuId = ""
    return menuId
}

export function setPageLink(pageLink){
    localStorage.setItem("pageLink", pageLink);
}

export function getPageLink(){
    var pageLink = localStorage.getItem("pageLink");
    if(pageLink === undefined)
    pageLink = ""
    return pageLink
}

export function setMenuPermission(permissions){
    var json = JSON.stringify(permissions);
    localStorage.setItem("permissions", json);
    return json;
}

export function getMenuPermission(key){
    var permission = localStorage.getItem("permissions");
    if(permission === undefined || permission === null || permission === "undefined"){
        return false
    }else{
        var json = JSON.parse(permission);
        console.log(json)
        var p = json.filter(x=>x===key)
        console.log(p)
        if(p.length > 0){
            return true
        }else{
            return false
        }
    }
}

export const breadcrumbContent = 
    {
        'AccountList' : {
            'title' : '系統帳號資訊',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"系統帳號管理",link:"/"},{content:"系統帳號管理"}]
        },
        'AccountAdd' : {
            'title' : '系統帳號資訊',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"系統帳號管理",link:"/"},{content:"系統帳號管理"}]
        },
        'FleetList' : {
            'title' : '車隊管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"車隊管理"}]
        },
        'FleetAdd' : {
            'title' : '車隊管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"車隊管理",link:"/FleetList"},{content:" 新增車隊"}]
        },
        'FleetEdit' : {
            'title' : '車隊管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"車隊管理",link:"/FleetList"},{content:"車隊編輯"}]
        },
        'FleetAssign' : {
            'title' : '車隊管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"車隊管理",link:"/FleetList"},{content:"車隊編輯"}]
        },
        'FleetMemberList' : {
            'title' : '車隊帳號管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/FleetList"},{content:"指定管理者"}]
        },
        'FleetMemberAdd' : {
            'title' : '車隊帳號管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊帳號管理",link:"/FleetMemberList"},{content:"帳號新增"}]
        },
        'FleetMemberEdit' : {
            'title' : '車隊帳號管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊帳號管理",link:"/FleetMemberList"},{content:"車隊編輯"}]
        },
        'FleetMemberAssign' : {
            'title' : '車隊帳號管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊帳號管理",link:"/FleetMemberList"},{content:"指定管理者"}]
        },
        'FleetCarList' : {
            'title' : '車隊車輛管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊車輛管理"}]
        },
        'FleetCarAdd' : {
            'title' : '車隊車輛管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊車輛管理",link:"/FleetCarList"},{content:"車輛編輯"}]
        },
        'FleetCarEdit' : {
            'title' : '車隊車輛管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊車輛管理",link:"/FleetCarList"},{content:"車輛編輯"}]
        },
        'FleetDriverList' : {
            'title' : '車隊司機管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊司機管理"}]
        },
        'FleetDriverAdd' : {
            'title' : '車隊司機管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊司機管理",link:"/FleetDriverList"},{content:"車隊司機新增"}]
        },
        'FleetDriverEdit' : {
            'title' : '車隊司機管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊司機管理",link:"/FleetDriverList"},{content:"車隊司機編輯"}]
        },
        'FleetCustomerList' : {
            'title' : '車隊客戶管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊客戶管理"}]
        },
        'FleetCustomerEdit' : {
            'title' : '車隊客戶管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊客戶管理",link:"/FleetCustomerList"},{content:"車隊客戶編輯"}]
        },
        'CustomerLocalPointList' : {
            'title' : '車隊客戶管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊客戶管理",link:"/FleetCustomerList"},{content:" 點位管理"}]
        },
        'CustomerLocalPointEdit' : {
            'title' : '車隊客戶管理',
            'breadcrumbs' :[{content:"首頁",link:"/"},{content:"基礎資料維護",link:"/"},{content:"車隊客戶管理",link:"/FleetCustomerList"},{content:" 點位編輯"}]
        },
    }

export const ListTitles = {
    AccountList: [
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "功能", width : "100px", sortClass: "sorting"},
        {name : "電話", width : "160px", sortClass: "sorting"},
        {name : "電郵", width : "160px", sortClass: "sorting"},
        {name : "姓名",  width : "100px", sortClass: "sorting"},
        {name : "車隊",  width : "160px", sortClass: "sorting"},
        {name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
    FleetList: [
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "資料維護", width : "100px", sortClass: "sorting"},
        {name : "管理者", width : "100px", sortClass: "sorting"},
        {name : "編號", width : "160px", sortClass: "sorting"},
        {name : "名稱", width : "200px", sortClass: "sorting"},
        {name : "所在縣市",  width : "100px", sortClass: "sorting"},
        {name : "客戶數",  width : "100px", sortClass: "sorting"},
        {name : "點位數",  width : "100px", sortClass: "sorting"},
        {name : "司機數",  width : "100px", sortClass: "sorting"},
        {name : "車輛數",  width : "100px", sortClass: "sorting"},
        {name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
    FleetMemberList: [
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "功能", width : "100px", sortClass: "sorting"},
        {name : "姓名", width : "160px", sortClass: "sorting"},
        {name : "手機", width : "160px", sortClass: "sorting"},
        {name : "建立日期",  width : "160px", sortClass: "sorting"},
        {name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
    FleetCarList: [
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "功能", width : "100px", sortClass: "sorting"},
        {name : "車牌", width : "160px", sortClass: "sorting"},
        {name : "保管人", width : "160px", sortClass: "sorting"},
        {name : "車種",  width : "100px", sortClass: "sorting"},
        {name : "部門",  width : "100px", sortClass: "sorting"},
        {name : "司機數",  width : "100px", sortClass: "sorting"},
        {name : "註記",  width : "100px", sortClass: "sorting"},
        //{name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
    FleetDriverList: [
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "功能", width : "100px", sortClass: "sorting"},
        {name : "姓名", width : "100px", sortClass: "sorting"},
        {name : "手機", width : "100px", sortClass: "sorting"},
        {name : "部門",  width : "100px", sortClass: "sorting"},
        {name : "建立日期",  width : "100px", sortClass: "sorting"},
        //{name : "最近停權日",  width : "100px", sortClass: "sorting"},
        {name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
    FleetCustomerList:[
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "資料維護", width : "100px", sortClass: "sorting"},
        {name : "點位管理", width : "100px", sortClass: "sorting"},
        {name : "名稱", width : "200px", sortClass: "sorting"},
        {name : "所在地",  width : "100px", sortClass: "sorting"},
        {name : "總點位數",  width : "100px", sortClass: "sorting"},
        {name : "智慧點",  width : "100px", sortClass: "sorting"},
        {name : "一般點",  width : "100px", sortClass: "sorting"},
        {name : "建立日期",  width : "100px", sortClass: "sorting"},
        //{name : "最近停權日",  width : "100px", sortClass: "sorting"},
        //{name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
    CustomerLocalPointList:[
        {name : "項次", width : "50px", sortClass: "sorting_asc"},
        {name : "功能", width : "50px", sortClass: "sorting"},
        //{name : "編號", width : "160px", sortClass: "sorting"},
        {name : "名稱", width : "200px", sortClass: "sorting"},
        {name : "縣市",  width : "100px", sortClass: "sorting"},
        {name : "區/鄉鎮",  width : "100px", sortClass: "sorting"},
        {name : "智慧點位",  width : "100px", sortClass: "sorting"},
        {name : "建立日期",  width : "100px", sortClass: "sorting"},
        //{name : "最近停權日",  width : "100px", sortClass: "sorting"},
        //{name : "啟用狀態",  width : "100px", sortClass: "sorting"},
    ],
}

export const ListColumns = {
    FleetList: [
        {name : "index", className : "text-center va-m sorting_1"},
        {name : "edit", action:"fleet_id", className : "text-center"},
        {name : "assign", action:"fleet_id", className : "text-center"},
        {name : "fleet_number", className : "text-center va-m"},
        {name : "fleet_name", className : "text-center va-m"},
        {name : "county",  className : "text-center va-m"},
        {name : "number_of_customers",  className : "text-right va-m"},
        {name : "number_of_locations",  className : "text-right va-m"},
        {name : "number_of_drivers",  className : "text-right va-m"},
        {name : "number_of_cars",  className : "text-right va-m"},
        {name : "enabled",  className : "text-center va-m"},
    ],
    FleetMemberList: [
        {name : "index", className : "text-center va-m sorting_1"},
        {name : "edit", action:"user_id", className : "text-center"},
        {name : "name", className : "text-center va-m"},
        {name : "mobile", className : "text-center va-m"},
        {name : "create_date",  className : "text-center va-m"},
        {name : "enabled",  className : "text-center va-m"},
    ],
    CarList: [
        {name : "index", className : "text-center va-m sorting_1"},
        {name : "edit", action:"car_id", className : "text-center"},
        {name : "car_plate_number", className : "text-center va-m"},
        {name : "keeper", className : "text-center va-m"},
        {name : "car_type",  className : "text-center va-m"},
        {name : "dept",  className : "text-center va-m"},
        {name : "number_of_drivers",  className : "text-center va-m"},
        {name : "note",  className : "text-center va-m"},
        //{name : "enabled",  className : "text-center va-m"},
    ],
    DriverList: [
        {name : "index", className : "text-center va-m sorting_1"},
        {name : "edit", action:"driver_id", className : "text-center"},
        {name : "driver_name", className : "text-center va-m"},
        {name : "driver_phone",  className : "text-center va-m"},
        {name : "driver_dept", className : "text-center va-m"},
        {name : "create_time",  className : "text-center va-m"},
        //{name : "enabled_time",  className : "text-center va-m"},
        {name : "enabled",  className : "text-center va-m"},
    ],
    CustomerList: [
        {name : "index", className : "text-center va-m sorting_1"},
        {name : "edit", action:"customer_id", className : "text-center"},
        {name : "view", action:"customer_id", className : "text-center"},
        {name : "company_name", className : "text-center va-m"},
        {name : "county",  className : "text-center va-m"},
        {name : "number_of_total_locations", className : "text-center va-m"},
        {name : "number_of_standard_locations",  className : "text-center va-m"},
        {name : "number_of_smart_locations",  className : "text-center va-m"},
        {name : "create_time",  className : "text-center va-m"},
    ],
    CustomerLocalPointList: [
        {name : "index", className : "text-center va-m sorting_1"},
        {name : "edit", action:"location_id", className : "text-center"},
        //{name : "location_id", className : "text-center va-m"},
        {name : "location_name",  className : "text-center va-m"},
        {name : "county",  className : "text-center va-m"},
        {name : "township",  className : "text-center va-m"},
        {name : "is_smart",  className : "text-center va-m"},
        {name : "create_time",  className : "text-center va-m"},
        //{name : "number_of_standard_locations",  className : "text-center va-m"},
        //{name : "enabled", className : "text-center va-m"},
    ]
}